<template>
  <div >
    <!-- <ion-grid class="page-content">
      <form @keyup.enter="signinWithOtp">
        <ion-row>
          <ion-col class="col-padding ion-text-center">
            <img src="/assets/images/logo/rapid.png" alt="Rapid Logo" class="logo" />
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-segment  :value="newSegmentName" @ionChange="newSegmentChanged($event)">
              <ion-segment-button value="customer">
                <ion-label>Customer</ion-label>
              </ion-segment-button>
              <ion-segment-button value="admin">
                <ion-label>Admin</ion-label>
              </ion-segment-button>
              <ion-segment-button value="carter">
                <ion-label>Carter</ion-label>
              </ion-segment-button>
            </ion-segment>
          </ion-col>
        </ion-row><br>
        <div v-if= "displayInd && !displayCarterInd">
          <ion-row class="rectangle-round">
            <ion-col>
              <ion-row>
                <ion-col class="col-padding">
                  <ion-label class="border-text" position="stacked">Mobile Number <span class="required">*</span></ion-label>
                  
                    <div class="border-line">
                      <ion-input
                        class="form-input"
                        type="tel"
                        placeholder="Enter Mobile Number"
                        @input="mobile = $event.target.value"
                        maxlength="100"
                      ></ion-input>
                    </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="ion-text-center">
                  <h6 class="accept-terms">By Signing In you accept to RapidEVCharge</h6>
                  <span class="dark-text ">
                    <a :href="this.termsAndConditionLink" target="_blank" >Terms &amp; Conditions</a>
                  </span>
                </ion-col>
              </ion-row><br>
              <ion-row>
                <ion-col>
                  <ion-button class="btn-primary" expand="block" @click="signinWithOtp" >Signin with OTP</ion-button> 
                </ion-col>
              </ion-row>
              <ion-row class="ion-text-center">
                <ion-col>
                  <p>Do not have an account? <span class="signIn" @click="signUp">SignUp</span></p>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </div>
      </form>
    </ion-grid>
    <ion-grid class="page-content" v-if = "!displayInd && !displayCarterInd">
      <form @keyup.enter="authLogin" >
        <ion-row class="rectangle-round">
          <ion-col>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">User Name</ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="tel"
                    placeholder="Enter Mobile Number / Email ID"
                    @input="mobile = $event.target.value"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">Password</ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="password"
                    placeholder="Enter Password"
                    @input="password = $event.target.value"
                    maxlength="50"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row class="ion-text-center">
          <ion-col>
            <ion-row>
              <ion-col>
                <ion-button class="btn-primary" expand="block" @click="authLogin">Login</ion-button> 
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
    <ion-grid class="page-content" v-if = "displayCarterInd">
      <form @keyup.enter="authLogin" >
        <ion-row class="rectangle-round">
          <ion-col>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">User Name</ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="tel"
                    placeholder="Enter Mobile Number / Email ID"
                    @input="mobile = $event.target.value"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">Password</ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="password"
                    placeholder="Enter Password"
                    @input="password = $event.target.value"
                    maxlength="50"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row class="ion-text-center">
          <ion-col>
            <ion-row>
              <ion-col>
                <ion-button class="btn-primary" expand="block" @click="authLogin">Login</ion-button> 
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid> -->
    <div >
    <!-- <ion-grid class="page-content">
      <form @keyup.enter="signinWithOtp">
        <ion-row>
          <ion-col class="col-padding ion-text-center">
            <img src="/assets/images/logo/rapid.png" alt="Rapid Logo" class="logo" v-if="displayFenfeoLogo"/>
            <img src="/assets/images/carter/carterLogo.jpeg" alt="Rapid Logo" class="logo" v-if="!displayFenfeoLogo"/>
          </ion-col>
        </ion-row> -->
        <!-- <ion-row>
          <ion-col>
            <ion-segment  :value="newSegmentName" @ionChange="newSegmentChanged($event)" color="success" select-on-focus="false">
              <ion-segment-button value="customer">
                <ion-label>Customer</ion-label>
              </ion-segment-button>
              <ion-segment-button value="admin">
                <ion-label>Admin</ion-label>
              </ion-segment-button>
            </ion-segment>
          </ion-col>
        </ion-row><br> -->

        <!-- <div v-if= "displayInd && !displayCarterInd">
          <ion-row class="rectangle-round">
            <ion-col>
              <ion-row>
                <ion-col class="col-padding">
                  <ion-label class="border-text" position="stacked">Mobile Number <span class="required">*</span></ion-label>
                  
                    <div class="border-line">
                      <ion-input
                        class="form-input"
                        type="tel"
                        placeholder="Enter Mobile Number"
                        @input="mobile = $event.target.value"
                        maxlength="100"
                      ></ion-input>
                    </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="ion-text-center">
                  <h6 class="accept-terms">By Signing In you accept to RapidEVCharge</h6>
                  <span class="dark-text ">
                    <a :href="this.termsAndConditionLink" target="_blank" >Terms &amp; Conditions</a>
                  </span>
                </ion-col>
              </ion-row><br>
              <ion-row>
                <ion-col>
                  <ion-button class="btn-primary" expand="block" @click="signinWithOtp" >Signin with OTP</ion-button> 
                </ion-col>
              </ion-row>
              <ion-row class="ion-text-center">
                <ion-col>
                  <p>Do not have an account? <span class="signIn" @click="signUp">SignUp</span></p>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </div> -->
      <!-- </form>
    </ion-grid> -->
    <ion-grid class="page-content">
      <ion-row>
        <ion-col class="col-padding ion-text-center">
          <img src="/assets/images/logo/rapid.png" alt="Rapid Logo" class="logo" v-if="displayFenfeoLogo"/>
          <img src="/assets/images/carter/carterLogo.jpeg" alt="Rapid Logo" class="logo" v-if="!displayFenfeoLogo"/>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
            <div class="flight-types">
                <input class="inm" type="radio" name="flight-type" value="customer" id="customer" checked/>
                <label class="lbl"  for="customer" @click="newSegmentChanged('customer')">
                  CUSTOMER
                </label>

                <input class="inm"  type="radio" name="flight-type" value="admin" id="admin"  />
                <label class="lbl" for="admin" @click="newSegmentChanged('admin')">
                  ADMIN
                </label>
            </div>
        </ion-col>
    </ion-row>
    </ion-grid>
    <div v-if= "displayInd && !displayCarterInd">
      <ion-grid class="page-content">
        <ion-row class="rectangle-round">
          <ion-col>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">Mobile Number <span class="required">*</span></ion-label>
                
                  <div class="border-line">
                    <ion-input
                      class="form-input"
                      type="tel"
                      placeholder="Enter Mobile Number"
                      @input="mobile = $event.target.value"
                      maxlength="100"
                    ></ion-input>
                  </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="ion-text-center">
                <h6 class="accept-terms">By Signing In you accept to RapidEVCharge</h6>
                <span class="dark-text ">
                  <a :href="this.termsAndConditionLink" target="_blank" >Terms &amp; Conditions</a>
                </span>
              </ion-col>
            </ion-row><br>
            <ion-row>
              <ion-col>
                <ion-button class="btn-primary" expand="block" @click="signinWithOtp" >Signin with OTP</ion-button> 
              </ion-col>
            </ion-row>
            <ion-row class="ion-text-center">
              <ion-col>
                <p>Do not have an account? <span class="signIn" @click="signUp">SignUp</span></p>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    
    <ion-grid class="page-content" v-if = "!displayInd && !displayCarterInd">
      <form @keyup.enter="authLogin" >
        <ion-row class="rectangle-round">
          <ion-col>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">User Name</ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Mobile Number / Email ID"
                    @input="mobile = $event.target.value"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">Password</ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="password"
                    placeholder="Enter Password"
                    @input="password = $event.target.value"
                    maxlength="50"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row class="ion-text-center">
          <ion-col>
            <ion-row>
              <ion-col>
                <ion-button class="btn-primary" expand="block" @click="authLogin">Login</ion-button> 
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
    <ion-grid class="page-content" v-if = "displayInd && displayCarterInd">
      <form @keyup.enter="carterAuthLogin" >
        <ion-row class="rectangle-round">
          <ion-col>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">User Name</ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Mobile Number / Email ID"
                    @input="mobile = $event.target.value"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">Password</ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="password"
                    placeholder="Enter Password"
                    @input="password = $event.target.value"
                    maxlength="50"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row class="ion-text-center">
          <ion-col>
            <ion-row>
              <ion-col>
                <ion-button class="btn-primary" expand="block" @click="carterAuthLogin">Login</ion-button> 
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>

    <div id="dummy-map"></div>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
  </div>
</template>
  
<script>
  // import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonInput,IonSegment, IonSegmentButton } from "@ionic/vue";
  // import { Capacitor, Plugins } from "@capacitor/core";
  // const { Geolocation } = Plugins;
  // import { ValidationUtils } from "../../util/validation-utils";
  // import { ToastUtils } from "../../util/toast-utils";
  // import { AuthenticationService } from "../../service/account/authenticator.service";
  // import { Credential, NewCredential } from "../../entity/authentication/credential";
  // import { LocalStorage } from "../../data/localstorage";
  // import { config } from "../../config";
  // import { SetAndGetValue } from "../../util/setAndGetValue-utils"

  import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonInput,IonSegment, IonSegmentButton } from "@ionic/vue";
  // import { Capacitor, Plugins } from "@capacitor/core";
  // const { Geolocation } = Plugins;
  import { ValidationUtils } from "../../util/validation-utils";
  import { ToastUtils } from "../../util/toast-utils";
  import { AuthenticationService } from "../../service/account/authenticator.service";
  import { Credential, NewCredential } from "../../entity/authentication/credential";
  import { LocalStorage } from "../../data/localstorage";
  import { config } from "../../config";
  import { SetAndGetValue } from "../../util/setAndGetValue-utils"
  import userData from "../../../public/assets/data/data.json";
  import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
  import { AlertUtils } from "../../util/alert-utils";

  export default {
  name: "login",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonLabel,
    IonInput,
    IonSegment, 
    IonSegmentButton
  },
  data: () => ({
    // password: "",
    // mobile: "",
    // displayInd: true,
    // segmentName: "customer",
    // termsCons: false,
    // termsAndConditionLink: config.api.host + "/common/static/images/tnc.html",
    // displayCarterInd: false,
    // newSegmentName: "carter"

    loaderTab: true,
    password: "",
    mobile: "",
    displayInd: true,
    segmentName: "customer",
    termsCons: false,
    termsAndConditionLink: config.api.host + "/common/static/images/tnc.html",
    displayCarterInd: false,
    newSegmentName: "customer",
    displayFenfeoLogo: true
    
  }),

  async mounted() {
    this.loaderTab = false;
    // localStorage.clear();
    // const element = document.getElementById("dummy-map");
    // const options = {
    //   zoom: 15,
    //   center: { lat: 13.021377, lng: 80.254227 }
    // };
    // var map = new google.maps.Map(element, options);
    // navigator.geolocation.getCurrentPosition(
    //   position => {
    //     var pos = {
    //       lat: position.coords.latitude,
    //       lng: position.coords.longitude
    //     };
    //     map.setCenter(pos);
    //   },
    //   error => {
    //     switch (error.code) {
    //       case error.PERMISSION_DENIED:
    //         console.log("User denied the request for Geolocation.");
    //         break;
    //       case error.POSITION_UNAVAILABLE:
    //         console.log("Location information is unavailable.");
    //         break;
    //       case error.TIMEOUT:
    //         console.log("The request to get user location timed out.");
    //         break;
    //       case error.UNKNOWN_ERROR:
    //         console.log("An unknown error occurred.");
    //         break;
    //     }
    //   }
    // );
  },
// OLD
  // methods: {
  //   newSegmentChanged(event) {
  //     alert(JSON.stringify(event.detail))
  //     if(event.detail.value == "customer") {
  //       this.displayInd = true;
  //       this.displayCarterInd = false;
  //     } else if(event.detail.value == "admin") {
  //       this.displayInd = false;
  //       this.displayCarterInd = true;
  //     }  else if(event.detail.value == "carter") {
  //       this.displayInd = false;
  //       this.displayCarterInd = true;
  //     }
  //   },
  //   segmentChanged(sel) {
  //     if(this.segmentName == "customer") {
  //       this.segmentName = "admin";
  //       this.displayInd = false;
  //     } else if(this.segmentName == "admin") {
  //       this.segmentName = "customer";
  //       this.displayInd = true;
  //     }  else if(this.segmentName == "carter") {
  //       this.segmentName = "customer";
  //       this.displayInd = true;
  //       this.displayCarterInd = true
  //     } 
  //     // if(this.displayInd) {
  //     //   this.displayInd = false
  //     // } else {
  //     //   this.displayInd = true
  //     // }
  //   },
  //   async signinWithOtp() {
  //     try {
  //       if(
  //         typeof this.mobile === "undefined" ||
  //         this.mobile === null ||
  //         this.mobile === ""
  //       ) {
  //         new ToastUtils().presentToast("Enter Mobile Number");
  //       } else if(new ValidationUtils().validateAlphaNumeric(this.mobile) === false) {
  //         new ToastUtils().presentToast("Enter Valid Mobile Number / Email ID");
  //       } else {
  //         window.localStorage.clear();
  //         let userInfo = await new AuthenticationService().newSigninUserWithCredential(
  //           new NewCredential(this.mobile)
  //         );
  //         // this.$router.push("/globalOTPVerification");
  //         localStorage.setItem('userInfo', JSON.stringify(userInfo));
  //         this.$router.push({
  //           name: "globalOTPVerification",
  //           params: {"userId": "userInfo.id"}
  //         })
  //         // this.$router.push("/signupverification");
          
  //       }
  //     } catch(error) {
  //       new ToastUtils().presentToast(error.response.data.errors[0].detail);
  //     }
  //   },
  //   async authLogin() {
  //     try {
  //       if (
  //         typeof this.mobile === "undefined" ||
  //         this.mobile === null ||
  //         this.mobile === ""
  //       ) {
  //         new ToastUtils().presentToast("Enter Mobile Number / Email ID");
  //       } 
  //       else if(new ValidationUtils().validateAlphaNumeric(this.mobile) === false) {
  //         new ToastUtils().presentToast("Enter Valid Mobile Number / Email ID");
  //       }
        
  //       else if (
  //         typeof this.password === "undefined" ||
  //         this.password === null ||
  //         this.password === ""
  //       ) {
  //         new ToastUtils().presentToast("Enter Password");
  //       } else {
  //         window.localStorage.clear();
  //         await new AuthenticationService().signinUserWithCredential(
  //           new Credential(this.mobile, this.password)
  //         );
  //         new ToastUtils().presentToast("Successfully logged in");
  //         this.$store.dispatch("logIn", new LocalStorage().user);
  //         this.$router.push({
  //           path: "/"
  //         });
  //       }
  //     } catch (error) {
  //       // let serviceError = tryParseServiceError(error);
  //       // new AlertUtils().presentAlert(serviceError ? serviceError : error);
  //       new ToastUtils().presentToast(error.response.data.errors[0].detail);
  //     }
  //   },
  //   forgotPassword() {
  //     this.$router.push("/forgotpassword");
  //   },
  //   signUp() {
  //     this.$router.push("/signup");
  //   }
  // }
  // NEW
  methods: {
    newSegmentChanged(event) {
      // if(event.detail.value == "customer") {
      //   this.displayInd = true;
      //   this.displayCarterInd = false;
      //   this.displayFenfeoLogo = true;
      // } else if(event.detail.value == "admin") {
      //   this.displayInd = false;
      //   this.displayCarterInd = false;
      //   this.displayFenfeoLogo = true;
      // }  else if(event.detail.value == "carter") {
      //   this.displayInd = true;
      //   this.displayCarterInd = true;
      //   this.displayFenfeoLogo = false;
      // }
      if(event == "customer") {
        this.displayInd = true;
        this.displayCarterInd = false;
        this.displayFenfeoLogo = true;
      } else if(event == "admin") {
        this.displayInd = false;
        this.displayCarterInd = false;
        this.displayFenfeoLogo = true;
      } else if(event == "carter") {
        this.displayInd = true;
        this.displayCarterInd = true;
        this.displayFenfeoLogo = false;
      }
    },
    segmentChanged(sel) {
      if(this.segmentName == "customer") {
        this.segmentName = "admin";
        this.displayInd = false;
      } else if(this.segmentName == "admin") {
        this.segmentName = "customer";
        this.displayInd = true;
      }  else if(this.segmentName == "carter") {
        this.segmentName = "customer";
        this.displayInd = true;
        this.displayCarterInd = true
      } 
      // if(this.displayInd) {
      //   this.displayInd = false
      // } else {
      //   this.displayInd = true
      // }
    },
    async signinWithOtp() {
      try {
        this.loaderTab = true;
        if(
          typeof this.mobile === "undefined" ||
          this.mobile === null ||
          this.mobile === ""
        ) {
          new ToastUtils().presentToast("Enter Mobile Number");
        } else if(new ValidationUtils().validateAlphaNumeric(this.mobile) === false) {
          new ToastUtils().presentToast("Enter Valid Mobile Number / Email ID");
        } else {
          window.localStorage.clear();
          let userInfo = await new AuthenticationService().newSigninUserWithCredential(
            new NewCredential(this.mobile)
          );
          // this.$router.push("/globalOTPVerification");
          this.loaderTab = false;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.$router.push({
            name: "globalOTPVerification",
            params: {"userId": "userInfo.id"}
          })
          // this.$router.push("/signupverification");
          
        }
        this.loaderTab = false;
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
        // new AlertUtils().presentAlert(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
      }
    },
    async authLogin() {
      try {
        this.loaderTab = true;
        if (
          typeof this.mobile === "undefined" ||
          this.mobile === null ||
          this.mobile === ""
        ) {
          new ToastUtils().presentToast("Enter Mobile Number / Email ID");
        } 
        else if(new ValidationUtils().validateAlphaNumeric(this.mobile) === false) {
          new ToastUtils().presentToast("Enter Valid Mobile Number / Email ID");
        }
        
        else if (
          typeof this.password === "undefined" ||
          this.password === null ||
          this.password === ""
        ) {
          new ToastUtils().presentToast("Enter Password");
        } else {
          window.localStorage.clear();
          await new AuthenticationService().signinUserWithCredential(
            new Credential(this.mobile, this.password)
          );
          new ToastUtils().presentToast("Successfully logged in");
          this.$store.dispatch("logIn", new LocalStorage().user);
          this.$router.push({
            path: "/"
          });
        }
        this.loaderTab = false;
      } catch (error) {
        this.loaderTab = false;
        // let serviceError = tryParseServiceError(error);
        // new AlertUtils().presentAlert(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },
    async carterAuthLogin() {
      try {
      if (
          typeof this.mobile === "undefined" ||
          this.mobile === null ||
          this.mobile === ""
        ) {
          new ToastUtils().presentToast("Enter Email ID");
        } 
        else if(new ValidationUtils().validateAlphaNumeric(this.mobile) === false) {
          new ToastUtils().presentToast("Enter Valid Email ID");
        } else if (
          typeof this.password === "undefined" ||
          this.password === null ||
          this.password === ""
        ) {
          new ToastUtils().presentToast("Enter Password");
        } else if(this.mobile !== userData.cred.userName) {
          new ToastUtils().presentToast("Invalid Email ID");
        } else if(this.password !== userData.cred.password) {
          new ToastUtils().presentToast("Invalid Password");
        }
        else {

          window.localStorage.clear();
          window.localStorage.setItem("user.id", 12345)
          this.$store.dispatch("logIn", new LocalStorage().user);
          this.$router.push({
            path: "/carter"
          });
          new ToastUtils().presentToast("Successfully logged in");

      }
      this.loaderTab = false;
      }catch(error){
        alert(error)
        this.loaderTab = false;
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
      }
    },
    forgotPassword() {
      this.$router.push("/forgotpassword");
    },
    signUp() {
      this.$router.push("/signup");
    }
  }
};
</script>
<!-- 
<style scoped>
ion-segment-button {
  border: 1px solid #1fe080;
  border-radius: 5px;
  margin: 1px;
}
  @media (min-width: 768px) {
    .loginForm {
      display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 120px;
    }
  }

  .termColor{
    color: rgb(11, 11, 203);
  }
  .dark-text {
    /* color: #8a8a8a; */
    font-size: 11px;
  }
  .signIn {
    cursor: pointer;
    color: #1fe080;
    font-weight: bold;
  }
  .accept-terms {
    font-size: 13px;
    margin-top: 0px;
  }
</style> -->

<style scoped>
.flight-types {
    display: flex;
    max-width: 336px;
    width: 100%;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    position: relative;
    z-index: 1;
    margin: 0 auto;
    font-size: 14px;
    /* border: 2px solid #161212; */
    border: 1.5px solid #041648;
    /* border-radius: 3px; */
    color: #0a3252;

}
.flight-types > input {
  display: none;
}
.flight-types > input:checked + label {
  /* color: #fbfbfb;
  background: #c8412b; */
  /* color: #21b24b;
  background: white; */
  background: #21b24b;
  color: white;
  font-weight: bold;

}
.flight-types > input:nth-of-type(1):checked ~ label:last-of-type:before {
  transform: translateX(calc(0% + 0px));
}
.flight-types > input:nth-of-type(2):checked ~ label:last-of-type:before {
  transform: translateX(calc(100% + 0px));
}
.flight-types > input:nth-of-type(3):checked ~ label:last-of-type:before {
  transform: translateX(calc(200% + 0px));
}
.flight-types label {
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  /* background: #21b24b;
  color: white; */

  color: #21b24b;
  background: white;
}
.flight-types label:last-of-type:before {
  content: "";
  display: block;
  max-width: calc(33.3333333333% - 0px);
  margin: 0px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  transform: translateX(0);
}
.flight-types label {
  padding: 6px 3px;
  transition: color 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types label:before {
  background: #fff;
  transition: all 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types label:not(:last-child) { 
  border-right: 1px solid #041648;
}
ion-segment-button {
  border: 1px solid #1fe080;
  border-radius: 5px;
  margin: 1px;
}
  @media (min-width: 768px) {
    .loginForm {
      display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 120px;
    }
  }

  .termColor{
    color: rgb(11, 11, 203);
  }
  .dark-text {
    /* color: #8a8a8a; */
    font-size: 11px;
  }
  .signIn {
    cursor: pointer;
    color: #1fe080;
    font-weight: bold;
  }
  .accept-terms {
    font-size: 13px;
    margin-top: 0px;
  }
</style>